<template>
	<app-page>
		<app-heading title="Enterprises">
			<template v-slot:left>
				<app-button v-if="$ravello.can('studeo_admin.post')"
					class="d-none d-sm-inline-flex"
					color="success"
					small
					outlined
					:to="{ name: 'studeo-enterprise', params: { enterprise: 'new' } }"
				>Connect Enterprise</app-button>
			</template>
			<template v-slot:right>
				<app-button
					color="secondary"
					icon="fa-sync"
					small
					outlined
					@click="syncShared()"
					v-if="$ravello.can('system.post')"
				>
					Sync shared data
				</app-button>
			</template>
		</app-heading>
		<app-row>
			<app-cell>
				<app-data-table
					:items="enterprises"
					:total="count"
					:refresh.sync="refresh"
					:headers="headers"
					@update="fetchEnterprises"
				>
					<template v-slot:active="{ item }">
						<app-icon v-if="item.active" icon="fa-check-circle" color="success" />
						<app-icon v-else icon="fa-times-circle" color="error" />
					</template>
					<template v-slot:actions="{ item }">
						<app-button
							v-if="$ravello.can('studeo_admin.put')"
							color="secondary"
							:to="{ name: 'studeo-enterprise', params: { enterprise: item._id } }"
							icon="fa-pencil-alt"
							table
						>
							Edit
						</app-button>
						<app-button-confirm
							color="secondary"
							icon="fa-sync"
							v-if="$ravello.can('system.post')"
							table
							label-confirm="Sync"
							:description="`Are you sure you want to sync enterprise <b>${item.name}</b>?`"
							title="Synchronize Enterprise"
							@click="syncEnterprise(item.slug)"
						>
							Sync
						</app-button-confirm>
						<app-button-confirm
							v-if="$ravello.can('user.delete')"
							color="error"
							icon="fa-unlink"
							table
							label-confirm="Disconnect"
							:description="`Are you sure you want to disconnect enterprise <b>${item.name}</b>?`
								+ `<br /><br /> Disabling it with the <b>inactive</b> status is better`
								+ ` in most case`"
							title="Disconnect Enterprise"
							@click="onDelete(item._id)"
						>
							Disconnect
						</app-button-confirm>
					</template>
				</app-data-table>
			</app-cell>
		</app-row>
		<app-floating-button
			class="d-inline-flex d-sm-none"
			:to="{ name: 'studeo-enterprise', params: { enterprise: 'new' } }"
			color="success"
			icon="fa-plus"
		/>
	</app-page>
</template>

<script>
export default {
	data() {
		return {
			enterprises: [],
			count: -1,
			refresh: false,
			headers: [{
				text: 'Is active?',
				value: 'active',
				sortable: true,
			}, {
				text: 'ID',
				value: 'studeo_id',
				sortable: true,
			}, {
				text: 'Name',
				value: 'name',
				sortable: true,
			}, {
				text: 'Slug',
				value: 'slug',
				sortable: true,
			}, {
				text: 'Connection profile slug',
				value: 'connection_profile_slug',
				sortable: false,
			}, {
				text: 'Actions',
				value: 'actions',
				align: 'end',
				sortable: false,
			}],
		}
	},
	methods: {
		async fetchEnterprises(pagination) {
			const request = this.$ravello.graphql('enterprises')
				.fromPagination(pagination)
				.fields(['_id', 'name', 'studeo_id', 'slug', 'connection_profile_slug', 'active'])

			if (this.count === -1) {
				request.count('count')
			}

			try {
				this.enterprises = await request.query()
				if (this.count === -1) {
					this.count = request.results.count
				}
			} catch (err) {
				this.$notifications.pushAlert('error', err.data.message)
			}
		},
		async syncShared() {
			this.$store.dispatch('app/startLoading')

			try {
				await this.$ravello.request()
					.to('system')
					.to('events')
					.to('trigger')
					.create({
						event: 'studeo.sync.shared',
					})
			} catch (err) {
				this.$notifications.pushAlert('error', err.data.message)
			}

			this.$store.dispatch('app/stopLoading')
		},
		async syncEnterprise(slug) {
			this.$store.dispatch('app/startLoading')

			try {
				await this.$ravello.request()
					.to('system')
					.to('events')
					.to('trigger')
					.create({
						event: 'studeo.sync',
						data: {
							enterprise: slug,
						},
					})
			} catch (err) {
				this.$notifications.pushAlert('error', err.data.message)
			}

			this.$store.dispatch('app/stopLoading')
		},

		async onDelete(id) {
			this.$store.dispatch('app/startLoading')
			try {
				await this.$ravello.request()
					.v(2)
					.to('enterprises')
					.to(id)
					.delete()

				this.$notifications.pushAlert('success', 'Enterprise successfully deleted')
				this.refresh = true
			} catch (err) {
				this.$notifications.pushAlert('error', err.data.message)
			}
			this.$store.dispatch('app/stopLoading')
		},
	},
}
</script>
